// Canonical backend action names, centralized here so route/nav/list-gating logic (and any UI
// code) reference one definition instead of scattering string literals like "list"/"view".
export const ACTIONS = {
  LIST: "list",
  CREATE: "create",
  EDIT: "edit",
  DETAIL: "detail",
  VIEW: "view",
  DELETE: "delete",
  ASSIGNEE: "assignee",
  OLD_DASHBOARD: "old_dashboard",
  NEW_DASHBOARD: "new_dashboard",
  LOCATION_FILTER: "location_filter",
  MEMBER_FILTER: "member_filter",
  DATE_RANGE: "date_range",
  PRODUCT_FILTER: "product_filter",
  CALLING_AGENT_BUTTON: "calling_agent_button",
  ADD: "add",
} as const;

export const ACTION_LIST = Object.values(ACTIONS);

export const ACTION_PATTERNS = {
  ADD: "_add",
} as const;

export const isAddAction = (actionName: string) => actionName.endsWith(ACTION_PATTERNS.ADD);

// e.g. `if (hasModuleAction(moduleActions, ACTIONS.LIST)) return <DataTable ... />;`
export const hasModuleAction = (moduleActions: string[] | undefined, actionName: string) =>
  Boolean(moduleActions?.includes(actionName));
